<div [loadingOverlay]="isLoading">
  <form [formGroup]="localProfileForm">
    <div *ngIf="!requireFullValidation && !localProfileForm.controls.isComplete.value" class="alert alert-warning mt-2"
      role="alert">
      A Business Profile Validation and Augmentation task has not been completed for this Local Profile.
    </div>
    <div class="d-flex flex-row mb-3">
      <div class="p-2">
        <label class="control-label d-block" for="isActive">Active</label>
        <div>
          <shared-components-customchoice id="isActive" formControlName="isActive"
            [disable]="isReadOnly || disableBusinessCitationEligibilityControls"></shared-components-customchoice>
        </div>
      </div>
      <div class="p-2" [formValidation]="localProfileForm.controls.isSubscribed">
        <label class="control-label d-block" for="isSubscribed">
          Subscribe Location
          <ng-container *ngIf="!isReadOnly && !disableBusinessCitationEligibilityControls">
            <app-components-helptext [key]="'LocalProfile_IsSubscribed'"></app-components-helptext>
          </ng-container>
        </label>
        <div>
          <shared-components-customchoice id="isSubscribed" formControlName="isSubscribed"
            [disable]="isReadOnly || disableBusinessCitationEligibilityControls"></shared-components-customchoice>
        </div>
      </div>
      <div class="p-2 ms-5">
        <label class="control-label d-block" for="isClosed">Location Is Closed</label>
        <div>
          <shared-components-customchoice id="isClosed" formControlName="isClosed"
            [disable]="isReadOnly"></shared-components-customchoice>
        </div>
      </div>
      <div class="p-2 ms-auto align-self-end">
        @if (researchData) {
          <button class="btn btn-primary align-self-start" (click)="toggleResearchVisibility()"><i class="fa-solid fa-book"></i>{{ isResearchVisible ? 'Hide Research' : 'Show Research' }}</button>
        }
        @if (partnerRequiresSso) {
          <button class="btn btn-primary" (click)="editOnPartnerSite()" [disabled]="isLoading"><i class="fas fa-sign-in-alt"></i>{{ partnerSsoLabel }}</button>
        }
      </div>
    </div>
    <hr />
    <h4>General Info</h4>
    @if (isResearchVisible) {
      <div class="row mb-3">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="companyName"></ng-container>
            <ng-container *ngTemplateOutlet="companyNameResearch"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="openingDate"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="countrySelection"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="streetAddress"></ng-container>
            <ng-container *ngTemplateOutlet="addressResearch"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="streetAddress2"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="city"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="stateAndZip"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="addressCheck"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="verifyAddress"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="hideStreetAddress"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="serviceAreaSelection"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="categorySelection"></ng-container>
            <ng-container *ngTemplateOutlet="categoryResearch"></ng-container>
            <ng-container *ngTemplateOutlet="previousCategories; context: { column: 'col-6'}"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="categoryAttributes"></ng-container>
          </div>
        </div>
      </div>
    } @else {
      <div class="row mb-3">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="companyName"></ng-container>
            <ng-container *ngTemplateOutlet="hideStreetAddress"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="openingDate"></ng-container>
            <ng-container *ngTemplateOutlet="serviceAreaSelection"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="countrySelection"></ng-container>
            <ng-container *ngTemplateOutlet="categorySelection"></ng-container>
            <ng-container *ngTemplateOutlet="previousCategories; context: { column: 'offset-6 col-6'}"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="streetAddress"></ng-container>
            <ng-container *ngTemplateOutlet="categoryAttributes"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="streetAddress2"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="city"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="stateAndZip"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="addressCheck"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="verifyAddress"></ng-container>
          </div>
        </div>
      </div>
    }

    <ng-template #companyName>
      <div class="col-6">
        <label class="form-label" for="companyName">Company Name</label>
        <input class="form-control" [formValidation]="localProfileForm.controls.companyName" type="text"
          formControlName="companyName" [disabled]="isReadOnly" [readonly]="isReadOnly" id="companyName"
          placeholder="Company Name" />
      </div>
    </ng-template>

    <ng-template #companyNameResearch>
      <div class="col-6">
        <label for="companyName"><i class="fa-solid fa-book text-success"></i>Company Name</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.CompanyName' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applyStringValue($event.target,'companyName',researchData.CompanyName)" [disabled]="isReadOnly || !researchData.CompanyName"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
    </ng-template>

    <ng-template #openingDate>
      <div class="col-6">
        <label class="form-label" for="openingDate">Opening Date</label>
        <input [formValidation]="localProfileForm.controls.openingDate" type="date" formControlName="openingDate"
          [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control" id="openingDate"
          pattern="\d{4}-\d{2}-\d{2}" placeholder="Opening Date" />
      </div>
    </ng-template>

    <ng-template #countrySelection>
      <div class="col-6">
        <label class="form-label" for="countryId">Country<span><app-components-helptext
              [key]="'LocalProfile_Country'"></app-components-helptext></span></label>
        <ng-select [formValidation]="localProfileForm.controls.countryId" id="countryId" [items]="countries"
          [clearable]="true" placeholder="Country" bindLabel="Name" bindValue="CountryId"
          formControlName="countryId"></ng-select>
      </div>
    </ng-template>

    <ng-template #streetAddress>
      <div class="col-6">
        <label class="form-label" for="streetAddress">Street Address</label>
        <input [formValidation]="localProfileForm.controls.streetAddress" type="text"
          formControlName="streetAddress" [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control"
          id="streetAddress" placeholder="Street Address" />
      </div>
    </ng-template>

    <ng-template #addressResearch>
      <div class="col-6">
        <label for="address"><i class="fa-solid fa-book text-success"></i>Address</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.Address' [ngModelOptions]="{standalone: true}" />
        </div>
      </div>
    </ng-template>

    <ng-template #streetAddress2>
      <div class="col-6">
        <label class="form-label" for="streetAddress2">Street Address 2</label>
        <input [formValidation]="localProfileForm.controls.streetAddress2" type="text"
          formControlName="streetAddress2" [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control"
          id="streetAddress2" placeholder="Street Address 2" />
      </div>
    </ng-template>

    <ng-template #city>
      <div class="col-6">
        <label class="form-label" for="city">City</label>
        <input [formValidation]="localProfileForm.controls.city" [disabled]="isReadOnly" [readonly]="isReadOnly"
          type="text" formControlName="city" class="form-control" id="city" placeholder="City/Suburb" />
      </div>
    </ng-template>

    <ng-template #stateAndZip>
      <div class="col-4">
        <label class="form-label" for="stateId">State</label>
        <ng-select [formValidation]="localProfileForm.controls.stateId" id="stateId" [items]="states"
          [clearable]="true" bindLabel="displayName" bindValue="StateId" formControlName="stateId"
          placeholder="State"></ng-select>
      </div>
      <div class="col-2">
        <label class="form-label" for="zip">Postal Code</label>
        <input [formValidation]="localProfileForm.controls.zip" type="text" formControlName="zip"
          class="form-control" id="zip" placeholder="Postal Code" [disabled]="isReadOnly" [readonly]="isReadOnly" />
      </div>
    </ng-template>

    <ng-template #addressCheck>
      <div class="col-6">
        <button (click)="checkAddress()" [disabled]="isReadOnly" type="button" class="btn btn-success">
          <i class="fa fa-check"></i>
          Check Address
        </button>
      </div>
    </ng-template>

    <ng-template #verifyAddress>
      <div class="col-6" [formValidation]="localProfileForm.controls.verifyAddressMatchesWithGoogle">
        <label class="control-label">Did you verify with Google that the Customer's address matches the City/Zip
          provided?</label>
        <div style="width:141px;">
          <shared-components-customchoice id="verifyAddressMatchesWithGoogle"
            formControlName="verifyAddressMatchesWithGoogle"
            [disable]="isReadOnly"></shared-components-customchoice>
        </div>
      </div>
    </ng-template>

    <ng-template #hideStreetAddress>
      <div class="col-6">
        <label class="form-label d-block" for="isStreetAddressHidden">Hide Street Address</label>
        <shared-components-customchoice id="isStreetAddressHidden" formControlName="isStreetAddressHidden"
          [disable]="isReadOnly"></shared-components-customchoice>
      </div>
    </ng-template>

    <ng-template #serviceAreaSelection>
      <div class="col-6">
        <label class="form-label" for="serviceArea">Service Areas</label>
        <ng-select [formValidation]="localProfileForm.controls.serviceAreas" id="serviceArea"
          [items]="serviceAreas$ | async" [clearable]="true" bindLabel="Description" formControlName="serviceAreas"
          [loading]="serviceAreaLoading" [minTermLength]="3" [typeahead]="serviceAreaInput$" [multiple]="true"
          placeholder="Service Areas" maxSelectedItems="20">
        </ng-select>
      </div>
    </ng-template>

    <ng-template #categorySelection>
      <div class="col-6">
        <label class="form-label" for="categories">Categories</label>
        <ng-select [formValidation]="localProfileForm.controls.categories" id="categories" [items]="categories"
          [clearable]="true" [multiple]="true" [closeOnSelect]="false" bindLabel="FullName"
          bindValue="BusinessCitationProviderCategoryId" [virtualScroll]="true" formControlName="categories"
          placeholder="Categories"></ng-select>
      </div>
    </ng-template>

    <ng-template #previousCategories let-column="column">
      <ng-container *ngIf="localProfileForm.controls.categories.value.length === 0 && localProfileForm.controls.previousCategories.value">
        <div [ngClass]="column">
          <label class="control-label">Previous Categories</label>
          <ul class="list-group">
            @for ( category of localProfileForm.controls.previousCategories.value; track category ) {
              <li class="list-group-item">{{category}}</li>
            }
          </ul>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #categoryResearch>
      <div class="col-6">
        <label for="categories"><i class="fa-solid fa-book text-success"></i>Categories</label>
        <div class="d-flex">
          <textarea disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.Categories.join("\n")' [ngModelOptions]="{standalone: true}"></textarea>
        </div>
      </div>
    </ng-template>

    <ng-template #categoryAttributes>
      <div class="col-6">
        <label class="control-label">Category Attributes</label>
        <app-components-shared-local-profile-attributes [primaryCategory]="localProfileForm.controls.categories.value[0]"
          [countryId]="localProfileForm.controls.countryId.value"
          [businessCitationProviderId]="localProfileForm.controls.businessCitationProviderId.value"
          [profileAttributes]="localProfileForm.controls.attributes" [isReadOnly]="isReadOnly">
        </app-components-shared-local-profile-attributes>
      </div>
    </ng-template>

    <hr />
    <h4>Contact Info</h4>
    @if (isResearchVisible) {
      <div class="row mb-3">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="companyPhone"></ng-container>
            <ng-container *ngTemplateOutlet="companyPhoneResearch"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="alternatePhone"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="fax"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="contactName"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="website"></ng-container>
            <ng-container *ngTemplateOutlet="websiteResearch"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="email"></ng-container>
            <ng-container *ngTemplateOutlet="emailResearch"></ng-container>
          </div>
        </div>
      </div>
    } @else {
      <div class="row mb-3">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="companyPhone"></ng-container>
            <ng-container *ngTemplateOutlet="contactName"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="alternatePhone"></ng-container>
            <ng-container *ngTemplateOutlet="website"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="fax"></ng-container>
            <ng-container *ngTemplateOutlet="email"></ng-container>
          </div>
        </div>
      </div>
    }

    <ng-template #companyPhone>
      <div class="col-6">
        <label class="form-label" for="phone">Company Phone</label>
        <input [formValidation]="localProfileForm.controls.phone" type="text" formControlName="phone"
          [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control" id="phone"
          placeholder="Company Phone" />
      </div>
    </ng-template>

    <ng-template #companyPhoneResearch>
      <div class="col-6">
        <label for="phone"><i class="fa-solid fa-book text-success"></i>Company Phone</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.CompanyPhone' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applyStringValue($event.target,'phone',researchData.CompanyPhone)" [disabled]="isReadOnly || !researchData.CompanyPhone"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
    </ng-template>

    <ng-template #alternatePhone>
      <div class="col-6">
        <label class="form-label" for="alternatePhone">Alternate Phone</label>
        <input [formValidation]="localProfileForm.controls.alternatePhone" type="text" [disabled]="isReadOnly"
          [readonly]="isReadOnly" formControlName="alternatePhone" class="form-control" id="alternatePhone"
          placeholder="Alternate Phone" />
      </div>
    </ng-template>

    <ng-template #fax>
      <div class="col-6">
        <label class="form-label" for="fax">Fax</label>
        <input [formValidation]="localProfileForm.controls.fax" type="text" formControlName="fax"
          class="form-control" [disabled]="isReadOnly" [readonly]="isReadOnly" id="fax" placeholder="Fax" />
      </div>
    </ng-template>

    <ng-template #contactName>
      <div class="col-6">
        <label class="form-label" for="contactName">Contact Name</label>
        <input [formValidation]="localProfileForm.controls.contactName" type="text" formControlName="contactName"
          [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control" id="contactName"
          placeholder="Contact Name" />
      </div>
    </ng-template>

    <ng-template #website>
      <div class="col-6">
        <label class="form-label" for="website">Website</label>
        <input [formValidation]="localProfileForm.controls.website" type="text" formControlName="website"
          [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control" id="website" placeholder="Website" />
      </div>
    </ng-template>

    <ng-template #websiteResearch>
      <div class="col-6">
        <label for="website"><i class="fa-solid fa-book text-success"></i>Website</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.Website' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applyStringValue($event.target,'website',researchData.Website)" [disabled]="isReadOnly || !researchData.Website"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
    </ng-template>

    <ng-template #email>
      <div class="col-6">
        <label class="form-label" for="email">Email</label>
        <input [formValidation]="localProfileForm.controls.email" type="text" formControlName="email"
          [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control" id="email" placeholder="Email" />
      </div>
    </ng-template>

    <ng-template #emailResearch>
      <div class="col-6">
        <label for="emails"><i class="fa-solid fa-book text-success"></i>Emails</label>
        <div class="d-flex">
          <textarea disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.Emails.join("\n")' [ngModelOptions]="{standalone: true}"></textarea>
        </div>
      </div>
    </ng-template>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="control-label d-block" for="showOperatingHours">Business Hours</label>
          <div>
            <shared-components-customchoice id="showOperatingHours" formControlName="showOperatingHours"
              choiceTrue="Post business hours" choiceFalse="Do not post business hours"
              [disable]="isReadOnly"></shared-components-customchoice>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="localProfileForm.controls.showOperatingHours.value" style="margin-top: 5px;">
      @if (isResearchVisible) {
        <div class="row mb-3">
          <div class="col-12">
            <div class="row mb-3 g-3">
              <ng-container *ngTemplateOutlet="standardHours"></ng-container>
            </div>
          </div>
          <div class="col-12">
            <div class="row mb-3 g-3">
              <ng-container *ngTemplateOutlet="specialHours"></ng-container>
            </div>
          </div>
        </div>
      } @else {
        <div class="row mb-3">
          <div class="col-12">
            <div class="row mb-3 g-3">
              <ng-container *ngTemplateOutlet="standardHours"></ng-container>
              <ng-container *ngTemplateOutlet="specialHours"></ng-container>
            </div>
          </div>
        </div>
      }
    </div>

    <ng-template #standardHours>
      <div class="col-6">
        <div class="card card-body bg-light">
          <div class="row">
            <label class="control-label">Standard Hours</label>
            <div class="col-12">
              <shared-components-customtoggle formControlName="isOpen247" label="Open 24/7"
                [disabled]="localProfileForm.controls.isByAppointmentOnly.value || isReadOnly"></shared-components-customtoggle>
            </div>
            <div class="col-12">
              <shared-components-customtoggle formControlName="isByAppointmentOnly" label="By Appointment Only"
                [disabled]="localProfileForm.controls.isOpen247.value || isReadOnly"></shared-components-customtoggle>
            </div>
          </div>
          <div
            *ngIf="!(localProfileForm.controls.isOpen247.value) && !(localProfileForm.controls.isByAppointmentOnly.value)"
            [formValidation]="localProfileForm.controls.businessHours">
            <div class="card mb-10px" formArrayName="businessHours"
              *ngFor="let businessHours of businessHoursForms.controls; let i = index; trackBy: trackByFormControl">
              <div class="card-body" [formGroupName]="i">
                <ng-container
                  *ngIf="{ showSplit: businessHours.controls.from2.value || businessHours.controls.to2.value } as variable">
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1"><span class="day-name">{{ businessHours.controls.dayOfWeek.value | dayName }}</span>
                      @if (!isReadOnly) {
                        <span>
                          <button class="btn btn-link text-decoration-none dropdown-toggle me-4 btn-sm" type="button" data-toggle="dropdown">Copy to</button>
                          <ul class="dropdown-menu" role="menu">
                            <button class="btn-link dropdown-item" (click)="copyBusinessHours(businessHours, [0,1,2,3,4,5,6])">All Days</button>
                            <button class="btn-link dropdown-item" (click)="copyBusinessHours(businessHours, [0,6])">Weekends</button>
                            <button class="btn-link dropdown-item" (click)="copyBusinessHours(businessHours, [1,2,3,4,5])">Weekdays</button>
                            <li><hr class="dropdown-divider"></li>
                            <button class="btn-link dropdown-item" [disabled]="businessHours.controls.dayOfWeek.value === 0" (click)="copyBusinessHours(businessHours, [0])">Sunday</button>
                            <button class="btn-link dropdown-item" [disabled]="businessHours.controls.dayOfWeek.value === 1"(click)="copyBusinessHours(businessHours, [1])">Monday</button>
                            <button class="btn-link dropdown-item" [disabled]="businessHours.controls.dayOfWeek.value === 2"(click)="copyBusinessHours(businessHours, [2])">Tuesday</button>
                            <button class="btn-link dropdown-item" [disabled]="businessHours.controls.dayOfWeek.value === 3"(click)="copyBusinessHours(businessHours, [3])">Wednesday</button>
                            <button class="btn-link dropdown-item" [disabled]="businessHours.controls.dayOfWeek.value === 4"(click)="copyBusinessHours(businessHours, [4])">Thursday</button>
                            <button class="btn-link dropdown-item" [disabled]="businessHours.controls.dayOfWeek.value === 5"(click)="copyBusinessHours(businessHours, [5])">Friday</button>
                            <button class="btn-link dropdown-item" [disabled]="businessHours.controls.dayOfWeek.value === 6"(click)="copyBusinessHours(businessHours, [6])">Saturday</button>
                          </ul>
                        </span> 
                      }
                    </h5>
                    <div>
                      <ng-container *ngIf="isReadOnly">
                        <span class="ms-3">
                          <input disabled readonly formControlName="isOpen24Hours" type="checkbox" /> 24 hours
                        </span>
                        <span class="ms-3">
                          <input disabled readonly formControlName="isClosed" type="checkbox" /> Closed
                        </span>
                      </ng-container>
                      <ng-container *ngIf="!isReadOnly">
                        <span class="ms-3">
                          <input formControlName="isOpen24Hours" (change)="isOpen24HoursChanged($event, businessHours)"
                            type="checkbox" /> 24 hours
                        </span>
                        <span class="ms-3">
                          <input formControlName="isClosed" (change)="isClosedChanged($event, businessHours)"
                            type="checkbox" /> Closed
                        </span>
                      </ng-container>
                    </div>
                  </div>
                  <div class="row align-items-end"
                    *ngIf="!businessHours.controls.isOpen24Hours.value && !businessHours.controls.isClosed.value">
                    <div class="col-9">
                      <div class="d-flex w-100 justify-content-center align-items-center">
                        <span>
                          <app-time-picker id="from1" formControlName="from1"></app-time-picker>
                        </span>
                        <span class="ms-3 me-3">to</span>
                        <span>
                          <app-time-picker id="to1" formControlName="to1"></app-time-picker>
                        </span>
                      </div>
                      <ng-container *ngIf="variable.showSplit">
                        <div class="d-flex w-100 mt-1 justify-content-center align-items-center">
                          <span>
                            <app-time-picker id="from2" formControlName="from2"></app-time-picker>
                          </span>
                          <span class="ms-3 me-3">to</span>
                          <span>
                            <app-time-picker id="to2" formControlName="to2"></app-time-picker>
                          </span>
                        </div>
                      </ng-container>
                    </div>
                    <div class="col-3">
                      <div class="d-flex w-100 justify-content-center align-items-center">
                        <ng-container *ngIf="!variable.showSplit">
                          <button [disabled]="isReadOnly" type="button" class="btn btn-sm btn-success"
                            (click)="variable.showSplit = true"><i class="fas fa-plus"></i>Split</button>
                        </ng-container>
                        <ng-container *ngIf="variable.showSplit">
                          <button [disabled]="isReadOnly" type="button" class="btn btn-sm btn-warning"
                            (click)="clearSecondInterval(businessHours); variable.showSplit = false;"><i
                              class="fas fa-trash"></i>Split</button>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div>
            <label for="additionalHoursInformation">Additional Hours Information</label>
            <textarea [formValidation]="localProfileForm.controls.additionalHoursInformation"
              formControlName="additionalHoursInformation" [disabled]="isReadOnly" [readonly]="isReadOnly"
              class="form-control" id="additionalHoursInformation"
              placeholder="Additional Hours Information"></textarea>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #specialHours>
      <div class="col-6">
        <div class="card card-body bg-light" style="overflow:auto; max-height: 1000px;">
          <div class="d-flex w-100 justify-content-between">
            <label class="control-label">Special Hours</label>
            <button [disabled]="isReadOnly" type="button" class="btn btn-sm btn-success"
              (click)="addSpecialHours()">Add</button>
          </div>
          <ng-container *ngIf="specialHoursForms.controls.length">
            <div style="margin-top: 5px;" [formValidation]="localProfileForm.controls.specialHours" [placement]="Position.left">
              <div class="card mb-10px" formArrayName="specialHours"
                *ngFor="let specialHours of specialHoursForms.controls; let i = index; trackBy: trackByFormControl">
                <div class="card-body" [formGroupName]="i">
                  <ng-container
                    *ngIf="{ showSplit: specialHours.controls.from2.value || specialHours.controls.to2.value } as variable">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">
                        <input class="form-control" formControlName="date" width="300px" type="date" name="date"
                          id="date" pattern="\d{4}-\d{2}-\d{2}" />
                      </h5>
                      <div>
                        <ng-container *ngIf="isReadOnly">
                          <span class="ms-3">
                            <input disabled readonly formControlName="isOpen24Hours" type="checkbox" /> 24 hours
                          </span>
                          <span class="ms-3">
                            <input disabled readonly formControlName="isClosed" type="checkbox" /> Closed
                          </span>
                        </ng-container>
                        <ng-container *ngIf="!isReadOnly">
                          <span class="ms-3">
                            <input formControlName="isOpen24Hours" (change)="isOpen24HoursChanged($event, specialHours)"
                              type="checkbox" /> 24 hours
                          </span>
                          <span class="ms-3">
                            <input formControlName="isClosed" (change)="isClosedChanged($event, specialHours)"
                              type="checkbox" /> Closed
                          </span>
                        </ng-container>
                      </div>
                      <i class="fas fa-trash" style="cursor: pointer;" (click)="removeSpecialHours(specialHours)"></i>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <input [disabled]="isReadOnly" [readonly]="isReadOnly" type="text"
                            formControlName="description" class="form-control" id="description"
                            placeholder="Description" />
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-end"
                      *ngIf="!specialHours.controls.isOpen24Hours.value && !specialHours.controls.isClosed.value">
                      <div class="col-9">
                        <div class="d-flex w-100 justify-content-center align-items-center">
                          <span>
                            <app-time-picker id="from1" formControlName="from1"></app-time-picker>
                          </span>
                          <span class="ms-3 me-3">to</span>
                          <span>
                              <app-time-picker id="to1" formControlName="to1"></app-time-picker>
                          </span>
                        </div>
                        <ng-container *ngIf="variable.showSplit">
                          <div class="d-flex w-100 mt-2 justify-content-center align-items-center">
                            <span>
                              <app-time-picker id="from2" formControlName="from2"></app-time-picker>
                            </span>
                            <span class="ms-3 me-3">to</span>
                            <span>
                              <app-time-picker id="to2" formControlName="to2"></app-time-picker>
                            </span>
                          </div>
                        </ng-container>
                      </div>
                      <div class="col-3">
                        <div class="d-flex w-100 mt-2 justify-content-center">
                          <ng-container *ngIf="!variable.showSplit">
                            <button [disabled]="isReadOnly" type="button" class="btn btn-sm btn-success"
                              (click)="variable.showSplit = true"><i class="fas fa-plus"></i>Split</button>
                          </ng-container>
                          <ng-container *ngIf="variable.showSplit">
                            <button [disabled]="isReadOnly" type="button" class="btn btn-sm btn-warning"
                              (click)="clearSecondInterval(specialHours); variable.showSplit = false;"><i
                                class="fas fa-trash"></i>Split</button>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-template>

    <hr />
    <h4>Business Info and Description</h4>
    @if (isResearchVisible) {
      <div class="row mb-1">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="featuredMessage"></ng-container>
            <ng-container *ngTemplateOutlet="featuredMessageResearch"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="description"></ng-container>
            <ng-container *ngTemplateOutlet="descriptionResearch"></ng-container>
          </div>
        </div>
      </div>
    } @else {
      <div class="row mb-1">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="featuredMessage"></ng-container>
            <ng-container *ngTemplateOutlet="description"></ng-container>
          </div>
        </div>
      </div>
    }

    <div class="row mb-1">
      <div class="col-12">
        <div class="row mb-3 g-3">
          <ng-container *ngTemplateOutlet="localProfileKeywords"></ng-container>
          @if (customerCampaignKeywords?.length) {
            <ng-container *ngTemplateOutlet="campaignKeywords"></ng-container>
          }
        </div>
      </div>
    </div>

    <ng-template #featuredMessage>
      <div class="col-6">
        <label for="featuredMessage">Featured Message</label>
        <textarea [formValidation]="localProfileForm.controls.featuredMessage" formControlName="featuredMessage"
          [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control" id="featuredMessage"
          placeholder="Featured Message"></textarea>
      </div>
    </ng-template>

    <ng-template #featuredMessageResearch>
      <div class="col-6">
        <label for="featuredMessage"><i class="fa-solid fa-book text-success"></i>Featured Message</label>
        <div class="d-flex">
          <textarea disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.FeaturedMessage' [ngModelOptions]="{standalone: true}"></textarea>
          <button class="btn btn-success text-nowrap align-self-start" (click)="applyStringValue($event.target,'featuredMessage',researchData.FeaturedMessage)" [disabled]="isReadOnly || !researchData.FeaturedMessage"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
    </ng-template>
    
    <ng-template #description>
      <div class="col-6">
        <label for="description">Description</label>
        <textarea [formValidation]="localProfileForm.controls.description" formControlName="description"
          [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control" id="description"
          placeholder="Description"></textarea>
      </div>
    </ng-template>

    <ng-template #descriptionResearch>
      <div class="col-6">
        <label for="description"><i class="fa-solid fa-book text-success"></i>Description</label>
        <div class="d-flex">
          <textarea disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.Description' [ngModelOptions]="{standalone: true}"></textarea>
          <button class="btn btn-success text-nowrap align-self-start" (click)="applyStringValue($event.target,'description',researchData.Description)" [disabled]="isReadOnly || !researchData.Description"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
    </ng-template>

    <ng-template #localProfileKeywords>
      <div class="col-6">
        <label class="form-label" for="keywords">Keywords</label>
        <ng-select
          [addTag]="true"
          class="hide-arrow"
          [clearable]="true"
          [clearSearchOnAdd]="true"
          [closeOnSelect]="false"
          formControlName="keywords"
          [formValidation]="localProfileForm.controls.keywords"
          id="keywords"
          [isOpen]="false"
          [items]="localProfileForm.controls.keywords.value"
          [multiple]="true"
          placeholder="Keywords"
          #select
          (blur)="select.selectTag()"></ng-select>
      </div>
    </ng-template>

    <ng-template #campaignKeywords>
      <div class="col-6">
        <label for="products"><i class="fa-solid fa-book text-success"></i>Campaign Keywords</label>
        @for (keyword of customerCampaignKeywords; track keyword) {
          <div class="d-flex">
            <input type="text" disabled readonly class="form-control flex-grow-1 me-2 mb-2" [ngModel]='keyword' [ngModelOptions]="{standalone: true}" />
            <button class="btn btn-success text-nowrap align-self-start" (click)="applyStringToList($event.target, 'keywords', keyword)" [disabled]="isReadOnly"><i class="fa-regular fa-copy"></i>Apply</button>
          </div>
        }
        @if (customerCampaignKeywords.length > 1) {
          <div class="d-flex align-items-end">
            <button class="btn btn-success text-nowrap ms-auto" (click)="applyStringsToList($event.target, 'keywords', customerCampaignKeywords)" [disabled]="isReadOnly"><i class="fa-regular fa-copy"></i>Apply All</button>
          </div>
        }
      </div>
    </ng-template>

    <hr />
    <h4>Social Media Profiles</h4>
    <div class="row mb-3">
      @if (isResearchVisible) {
        <div class="col-6">
          <div class="row g-3">
            <ng-container *ngTemplateOutlet="socialProfiles; context: { column: 'col-12'}" ></ng-container>
          </div>
        </div>
        <div class="col-6">
          <div class="row g-3">
            <ng-container *ngTemplateOutlet="socialProfileResearch"></ng-container>
          </div>
        </div>
      } @else {
        <div class="col-12">
          <div class="row g-3">
            <ng-container *ngTemplateOutlet="socialProfiles; context: { column: 'col-6'}" ></ng-container>
          </div>
        </div>
      }
    </div>

    <ng-template #socialProfiles let-column="column">
      <ng-container formGroupName="socialProfiles">
        <div *ngFor="let socialProfileForm of socialProfileForms.controls; let i = index;" [formGroupName]="i" [ngClass]="column">
          <label class="form-label">{{ socialProfileForm.controls.name.value }}</label>
          <div class="input-group">
            @if (socialProfileForm.controls.accountPrefix.value)
            {
            <span class="input-group-text">{{ socialProfileForm.controls.accountPrefix.value }}</span>
            } @else if (socialProfileForm.controls.prependBaseUrl.value) {
            <span class="input-group-text">{{ socialProfileForm.controls.baseUrl.value }}</span>
            }
            <input [disabled]="isReadOnly" [formValidation]="socialProfileForm.controls.url" [readonly]="isReadOnly" type="text"
              formControlName="url" class="form-control" [placeholder]="socialProfileForm.controls.example.value" />
          </div>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #socialProfileResearch>
      <div class="col-12">
        <label for="facebook"><i class="fa-solid fa-book text-success"></i>Facebook</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.Facebook' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applySocialProfileValue($event.target,'Facebook',researchData.Facebook)" [disabled]="isReadOnly || !researchData.Facebook"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
      <div class="col-12">
        <label for="instagram"><i class="fa-solid fa-book text-success"></i>Instagram</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.Instagram' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applySocialProfileValue($event.target,'Instagram',researchData.Instagram)" [disabled]="isReadOnly || !researchData.Instagram"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
      <div class="col-12">
        <label for="linkedIn"><i class="fa-solid fa-book text-success"></i>LinkedIn</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.LinkedIn' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applySocialProfileValue($event.target,'LinkedIn',researchData.LinkedIn)" [disabled]="isReadOnly || !researchData.LinkedIn"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
      <div class="col-12">
        <label for="pinterest"><i class="fa-solid fa-book text-success"></i>Pinterest</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.Pinterest' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applySocialProfileValue($event.target,'Pinterest',researchData.Pinterest)" [disabled]="isReadOnly || !researchData.Pinterest"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
      <div class="col-12">
        <label for="twitter"><i class="fa-solid fa-book text-success"></i>Twitter</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.Twitter' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applySocialProfileValue($event.target,'Twitter',researchData.Twitter)" [disabled]="isReadOnly || !researchData.Twitter"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
      <div class="col-12">
        <label for="youTube"><i class="fa-solid fa-book text-success"></i>YouTube</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.YouTube' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applySocialProfileValue($event.target,'YouTube',researchData.YouTube)" [disabled]="isReadOnly || !researchData.YouTube"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
    </ng-template>

    <hr />
    <h4>Rich Data</h4>
    @if (isResearchVisible) {
      <div class="row mb-3">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="paymentOptionSelection"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="products"></ng-container>
            <ng-container *ngTemplateOutlet="productsResearch"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="services"></ng-container>
            <ng-container *ngTemplateOutlet="servicesResearch"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="languageSelection"></ng-container>
            <ng-container *ngTemplateOutlet="languageResearch"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="associations"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="specialties"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="additionalInformation"></ng-container>
          </div>
        </div>
      </div>
    } @else {
      <div class="row mb-3">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="paymentOptionSelection"></ng-container>
            <ng-container *ngTemplateOutlet="languageSelection"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="products"></ng-container>
            <ng-container *ngTemplateOutlet="associations"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="services"></ng-container>
            <ng-container *ngTemplateOutlet="specialties"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <div class="col-6"><!-- intentional placeholder --></div>
            <ng-container *ngTemplateOutlet="additionalInformation"></ng-container>
          </div>
        </div>
      </div>
    }

    <ng-template #paymentOptionSelection>
      <div class="col-6">
        <label class="form-label d-block" for="paymentOptions">Payment Options</label>
        <ng-select id="paymentOptions" [items]="paymentOptions" [multiple]="true" [clearable]="true"
          bindLabel="Name" bindValue="PaymentOptionId" [closeOnSelect]="false" formControlName="paymentOptions"
          placeholder="Payment Options"></ng-select>
      </div>
      </ng-template>

    <ng-template #products>
      <div class="col-6">
        <label class="form-label" for="products">Products and Brands</label>
        <ng-select
          [addTag]="true"
          class="hide-arrow"
          [clearable]="true"
          [clearSearchOnAdd]="true"
          [closeOnSelect]="false"
          formControlName="products"
          [formValidation]="localProfileForm.controls.products"
          id="products"
          [isOpen]="false"
          [items]="localProfileForm.controls.products.value"
          [multiple]="true"
          placeholder="Products"
          #select
          (blur)="select.selectTag()"></ng-select>
      </div>
    </ng-template>

    <ng-template #languageSelection>
      <div class="col-6">
        <label class="form-label d-block" for="languages">Languages</label>
        <ng-select id="languages" [items]="languages" [multiple]="true" [clearable]="true" bindLabel="Name"
          bindValue="Name" [closeOnSelect]="false" formControlName="languages" placeholder="Languages"></ng-select>
      </div>
    </ng-template>

    <ng-template #services>
      <div class="col-6">
        <label class="form-label" for="services">Services</label>
        <ng-select
          [addTag]="true"
          class="hide-arrow"
          [clearable]="true"
          [clearSearchOnAdd]="true"
          [closeOnSelect]="false"
          formControlName="services"
          [formValidation]="localProfileForm.controls.services"
          id="services"
          [isOpen]="false"
          [items]="localProfileForm.controls.services.value"
          [multiple]="true"
          placeholder="Services"
          #select
          (blur)="select.selectTag()"></ng-select>
      </div>
    </ng-template>

    <ng-template #associations>
      <div class="col-6">
        <label class="form-label" for="associations">Associations</label>
        <ng-select
          [addTag]="true"
          class="hide-arrow"
          [clearable]="true"
          [clearSearchOnAdd]="true"
          [closeOnSelect]="false"
          formControlName="associations"
          [formValidation]="localProfileForm.controls.associations"
          id="associations"
          [isOpen]="false"
          [items]="localProfileForm.controls.associations.value"
          [multiple]="true"
          placeholder="Associations"
          #select
          (blur)="select.selectTag()"></ng-select>
      </div>
    </ng-template>

    <ng-template #specialties>
      <div class="col-6">
        <label class="form-label" for="specialties">Specialties</label>
        <ng-select
          [addTag]="true"
          class="hide-arrow"
          [clearable]="true"
          [clearSearchOnAdd]="true"
          [closeOnSelect]="false"
          formControlName="specialties"
          [formValidation]="localProfileForm.controls.specialties"
          id="specialties"
          [isOpen]="false"
          [items]="localProfileForm.controls.specialties.value"
          [multiple]="true"
          placeholder="Specialties"
          #select
          (blur)="select.selectTag()"></ng-select>
      </div>
    </ng-template>

    <ng-template #additionalInformation>
      <div class="col-6">
        <label class="form-label" for="notes">Additional Information: qualifications, certifications, awards, and so on.</label>
        <textarea [formValidation]="localProfileForm.controls.notes" formControlName="notes" [disabled]="isReadOnly"
          [readonly]="isReadOnly" class="form-control" id="notes" rows="6"
          placeholder="Additional Information"></textarea>
      </div>
    </ng-template>

    <ng-template #languageResearch>
      <div class="col-6">
        <label for="languageCode"><i class="fa-solid fa-book text-success"></i>Language Code</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.LanguageCode' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applyLanguageCode($event.target, researchData.LanguageCode)" [disabled]="isReadOnly || !researchData.LanguageCode"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
    </ng-template>

    <ng-template #productsResearch>
      <div class="col-6">
        <label for="products"><i class="fa-solid fa-book text-success"></i>Products and Brands</label>
          @if (researchData.ProductsAndBrands.length === 0) {
            <div class="d-flex">
              <input type="text" disabled readonly class="form-control flex-grow-1 me-2 mb-2" value="" />
              <button class="btn btn-success text-nowrap align-self-start" [disabled]="true"><i class="fa-regular fa-copy"></i>Apply</button>
            </div>
          }
          @for (product of researchData.ProductsAndBrands; track product) {
            <div class="d-flex">
              <input type="text" disabled readonly class="form-control flex-grow-1 me-2 mb-2" [ngModel]='product' [ngModelOptions]="{standalone: true}" />
              <button class="btn btn-success text-nowrap align-self-start" (click)="applyStringToList($event.target, 'products', product)" [disabled]="isReadOnly"><i class="fa-regular fa-copy"></i>Apply</button>
            </div>
          }
          @if (researchData.ProductsAndBrands.length > 1) {
            <div class="d-flex align-items-end">
              <button class="btn btn-success text-nowrap ms-auto" (click)="applyStringsToList($event.target, 'products', researchData.ProductsAndBrands)" [disabled]="isReadOnly"><i class="fa-regular fa-copy"></i>Apply All</button>
            </div>
          }
      </div>
    </ng-template>

    <ng-template #servicesResearch>
      <div class="col-6">
        <label for="products"><i class="fa-solid fa-book text-success"></i>Services</label>
        @if (researchData.Services.length === 0) {
          <div class="d-flex">
            <input type="text" disabled readonly class="form-control flex-grow-1 me-2 mb-2" value="" />
            <button class="btn btn-success text-nowrap align-self-start" [disabled]="true"><i class="fa-regular fa-copy"></i>Apply</button>
          </div>
        }
        @for (service of researchData.Services; track service) {
          <div class="d-flex">
            <input type="text" disabled readonly class="form-control flex-grow-1 me-2 mb-2" [ngModel]='service' [ngModelOptions]="{standalone: true}" />
            <button class="btn btn-success text-nowrap align-self-start" (click)="applyStringToList($event.target, 'services', service)" [disabled]="isReadOnly"><i class="fa-regular fa-copy"></i>Apply</button>
          </div>
        }
        @if (researchData.Services.length > 1) {
          <div class="d-flex align-items-end">
            <button class="btn btn-success text-nowrap ms-auto" (click)="applyStringsToList($event.target, 'services', researchData.Services)" [disabled]="isReadOnly"><i class="fa-regular fa-copy"></i>Apply All</button>
          </div>
        }
      </div>
    </ng-template>

    <hr />
    <h4>Photos & Videos</h4>
    @if (isResearchVisible) {
      <div class="row mb-3">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="imageUrls"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="logoUrl"></ng-container>
            <ng-container *ngTemplateOutlet="logoUrlResearch"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="googleProfilePhoto"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="videoUrls"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="googleCoverPhoto"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="googlePreferredPhoto"></ng-container>
          </div>
        </div>
      </div>
    } @else {
      <div class="row mb-3">
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="imageUrls"></ng-container>
            <ng-container *ngTemplateOutlet="videoUrls"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="logoUrl"></ng-container>
            <ng-container *ngTemplateOutlet="googleCoverPhoto"></ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="row mb-3 g-3">
            <ng-container *ngTemplateOutlet="googleProfilePhoto"></ng-container>
            <ng-container *ngTemplateOutlet="googlePreferredPhoto"></ng-container>
          </div>
        </div>
      </div>
    }

    <ng-template #imageUrls>
      <div class="col-6">
        <label class="form-label" for="imageUrls">Image URLs</label>
        <textarea [formValidation]="localProfileForm.controls.imageUrls" [disabled]="isReadOnly"
          [readonly]="isReadOnly" formControlName="imageUrls" [disabled]="isReadOnly" [readonly]="isReadOnly"
          class="form-control" id="imageUrls" rows="6" placeholder="Image URLs"></textarea>
      </div>
    </ng-template>

    <ng-template #videoUrls>
      <div class="col-6">
        <label class="form-label" for="videoUrls">Video URLs</label>
        <textarea [formValidation]="localProfileForm.controls.videoUrls" [disabled]="isReadOnly"
          [readonly]="isReadOnly" formControlName="videoUrls" [disabled]="isReadOnly" [readonly]="isReadOnly"
          class="form-control" id="videoUrls" rows="16" placeholder="Video URLs"></textarea>
      </div>
    </ng-template>

    <ng-template #logoUrl>
      <div class="col-6">
        <label class="form-label" for="logoUrl">Logo URL</label>
        <input [formValidation]="localProfileForm.controls.logoUrl" type="text" [disabled]="isReadOnly"
          [readonly]="isReadOnly" formControlName="logoUrl" class="form-control" id="logoUrl"
          placeholder="Logo URL" />
      </div>
    </ng-template>

    <ng-template #logoUrlResearch>
      <div class="col-6">
        <label for="logoUrl"><i class="fa-solid fa-book text-success"></i>Logo URL</label>
        <div class="d-flex">
          <input type="text" disabled readonly class="form-control flex-grow-1 me-2" [ngModel]='researchData.BusinessLogo' [ngModelOptions]="{standalone: true}" />
          <button class="btn btn-success text-nowrap align-self-start" (click)="applyStringValue($event.target,'logoUrl',researchData.BusinessLogo)" [disabled]="isReadOnly || !researchData.BusinessLogo"><i class="fa-regular fa-copy"></i>Apply</button>
        </div>
      </div>
    </ng-template>

    <ng-template #googleCoverPhoto>
      <div class="col-6">
        <label class="form-label" for="googleCoverPhoto">Google Cover Photo</label>
        <input [formValidation]="localProfileForm.controls.googleCoverPhoto" type="text"
          formControlName="googleCoverPhoto" [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control"
          id="googleCoverPhoto" placeholder="Google Cover Photo" />
      </div>
    </ng-template>

    <ng-template #googleProfilePhoto>
      <div class="col-6">
        <label class="form-label" for="googleProfilePhoto">Google Profile Photo</label>
        <input [formValidation]="localProfileForm.controls.googleProfilePhoto" type="text"
          formControlName="googleProfilePhoto" [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control"
          id="googleProfilePhoto" placeholder="Google Profile Photo" />
      </div>
    </ng-template>

    <ng-template #googlePreferredPhoto>
      <div class="col-6">
        <label class="form-label" for="googlePreferredPhoto">Google Preferred Photo</label>
        <input [formValidation]="localProfileForm.controls.googleProfilePhoto" type="text"
          formControlName="googlePreferredPhoto" [disabled]="isReadOnly" [readonly]="isReadOnly"
          class="form-control" id="googlePreferredPhoto" placeholder="Google Preferred Photo" />
      </div>
    </ng-template>

    <ng-container *ngIf="showRegistration">
      <hr />
      <h4>Registration</h4>
      <div class="row mb-3">
        <div class="col-6">
          <div class="row g-3">
            <div class="col-6">
              <label class="form-label" for="googleListingClaimedByStatusId">Google Listing Claimed By?</label>
              <ng-select [formValidation]="localProfileForm.controls.googleListingClaimedByStatusId"
                id="googleListingClaimedByStatusId" [items]="listingClaimedByStatuses" [clearable]="false"
                bindLabel="Name" bindValue="ListingClaimedByStatusId"
                formControlName="googleListingClaimedByStatusId"></ng-select>
            </div>
            <ng-container *ngIf="true || !(localProfileForm.controls.googleListingClaimedByStatusId.value > 1)">
              <div class="col-6">
                <label class="form-label" for="googleRegistrationPhoneNumber">Google Registration Phone</label>
                <input [formValidation]="localProfileForm.controls.googleRegistrationPhoneNumber" type="text"
                  formControlName="googleRegistrationPhoneNumber" [disabled]="true" [readonly]="true"
                  class="form-control" id="googleRegistrationPhoneNumber" placeholder="Google Registration Phone" />
              </div>
            </ng-container>
            <div class="col-12">
              <label class="form-label" for="googleProfileUrl">Google Profile URL</label>
              <input [formValidation]="localProfileForm.controls.googleProfileUrl" type="text"
                formControlName="googleProfileUrl" [disabled]="isReadOnly" [readonly]="isReadOnly" class="form-control"
                id="googleProfileUrl" placeholder="Google Profile URL" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label" for="registrationEmail">Registration Email</label>
              <input [formValidation]="localProfileForm.controls.registrationEmail" type="text"
                formControlName="registrationEmail" [disabled]="true" [readonly]="true" class="form-control"
                id="registrationEmail" placeholder="Registration Email" />
            </div>
            <div class="col-12">
              <label class="form-label" for="registrationPassword">Registration Password</label>
              <input [formValidation]="localProfileForm.controls.registrationPassword" type="text"
                formControlName="registrationPassword" [disabled]="true" [readonly]="true" class="form-control"
                id="registrationPassword" placeholder="Registration Password" />
            </div>
            <ng-container *ngIf="registrationPhoneNumber">
              <div class="col-12">
                <label class="form-label" for="registrationPhone">Registration Phone Number</label>
                <div class="input-group">
                  <input type="text" [disabled]="true" [readonly]="true" [value]="registrationPhoneNumber.PhoneNumber"
                    [disabled]="true" [readonly]="true" class="form-control" id="registrationPhone"
                    placeholder="Registration Phone Number" />
                  <button (click)="requestNewPhoneNumber()" class="btn btn-danger">
                    <i class="fa fa-phone"></i>Request New
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>